import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { OffersResponse } from 'src/app/shared/interfaces/offer.interface';
import { environment } from 'src/environments/environment';


@Injectable()
export class OfferHandler {
  constructor(
    private http: HttpClient
  ) { }

  getOfferBenefits(): Observable<OffersResponse> {
    const endpoint = environment.staticScripts.staticAssets + 'json/offer-account-opening.json';
    return this.http.get<OffersResponse>(endpoint);
  }
}
